import { BarChart } from "@/components/charts";
import { ax } from "@/core";
import { StandardBox, useApi, useToken, useUIContext } from "@msuite/picasso";
import type { FC } from "react";

export const ConstructionSitesInvoicesChart: FC = () => {
	/** Context */
	const { colors } = useUIContext();
	const green = useToken("colors", colors.emerald);
	const red = useToken("colors", colors.red);
	const yellow = useToken("colors", colors.amber);
	const orange = useToken("colors", colors.orange);

	/** Hooks */
	const { data } = useApi<{ contractSums: 0; calculated: 0 }>(ax, {
		url: "/v2/construction-sites/dashboard/invoices",
		dependencies: ["construction-sites", "invoices"],
	});

	/** Render */
	return (
		<StandardBox>
			<BarChart
				title="Abrechnungen"
				description="Jahr 2025"
				colors={[green, red, yellow, orange]}
				data={[
					{
						name: "Auftragssummen",
						Summe: data?.contractSums,
					},
					{
						name: "Abrechnungssummen",
						Summe: data?.calculated,
					},
				]}
				dataKeys={["Summe"]}
			/>
		</StandardBox>
	);
};
